"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerAppApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var SignerAppApi = /** @class */ (function (_super) {
    __extends(SignerAppApi, _super);
    function SignerAppApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint for Esign Disclosure OptIn
     */
    SignerAppApi.prototype.esignDisclosureOptInRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, result, localVarUseFormData, formData, jsonData, body, jsonBody_1, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters["esignDisclosureOptInRequest"] == null) {
                            throw new runtime.RequiredError("esignDisclosureOptInRequest", 'Required parameter "esignDisclosureOptInRequest" was null or undefined when calling esignDisclosureOptIn().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        result = runtime.generateFormData(requestParameters.esignDisclosureOptInRequest, index_1.attributeTypeMapEsignDisclosureOptInRequest);
                        localVarUseFormData = result.localVarUseFormData;
                        formData = result.formData;
                        jsonData = result.jsonData;
                        if (localVarUseFormData) {
                            /**
                             * IMPORTANT: WE MUST DELETE "Content-Type"!
                             * When a request is multipart/form-data we must NOT set Content-Type
                             * otherwise the browser will mess up the boundary!
                             */
                            delete headerParameters["Content-Type"];
                            jsonBody_1 = (0, index_1.EsignDisclosureOptInRequestToJSON)(jsonData);
                            Object.keys(jsonBody_1).forEach(function (key) {
                                if (jsonBody_1[key] == null) {
                                    return;
                                }
                                formData.append(key, jsonBody_1[key]);
                            });
                            body = formData;
                        }
                        else {
                            headerParameters["Content-Type"] = "application/json";
                            body = (0, index_1.EsignDisclosureOptInRequestToJSON)(requestParameters.esignDisclosureOptInRequest);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/signer-app/esignDisclosureOptIn",
                                method: "POST",
                                headers: headerParameters,
                                query: queryParameters,
                                body: body,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Endpoint for Esign Disclosure OptIn
     */
    SignerAppApi.prototype.esignDisclosureOptIn = function (esignDisclosureOptInRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.esignDisclosureOptInRaw({ esignDisclosureOptInRequest: esignDisclosureOptInRequest }, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Endpoint for declining a signature request
     */
    SignerAppApi.prototype.reassignRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters["tsmGuid"] == null) {
                            throw new runtime.RequiredError("tsmGuid", 'Required parameter "tsmGuid" was null or undefined when calling reassign().');
                        }
                        if (requestParameters["newSignerName"] == null) {
                            throw new runtime.RequiredError("newSignerName", 'Required parameter "newSignerName" was null or undefined when calling reassign().');
                        }
                        if (requestParameters["newSignerEmail"] == null) {
                            throw new runtime.RequiredError("newSignerEmail", 'Required parameter "newSignerEmail" was null or undefined when calling reassign().');
                        }
                        if (requestParameters["delegateReason"] == null) {
                            throw new runtime.RequiredError("delegateReason", 'Required parameter "delegateReason" was null or undefined when calling reassign().');
                        }
                        queryParameters = {};
                        if (requestParameters["tsmGuid"] != null) {
                            queryParameters["tsm_guid"] = requestParameters["tsmGuid"];
                        }
                        if (requestParameters["newSignerName"] != null) {
                            queryParameters["new_signer_name"] = requestParameters["newSignerName"];
                        }
                        if (requestParameters["newSignerEmail"] != null) {
                            queryParameters["new_signer_email"] = requestParameters["newSignerEmail"];
                        }
                        if (requestParameters["delegateReason"] != null) {
                            queryParameters["delegate_reason"] = requestParameters["delegateReason"];
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/signer/delegate",
                                method: "POST",
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return (0, index_1.SuccessResponseFromJSON)(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Endpoint for declining a signature request
     */
    SignerAppApi.prototype.reassign = function (tsmGuid, newSignerName, newSignerEmail, delegateReason, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reassignRaw({
                            tsmGuid: tsmGuid,
                            newSignerName: newSignerName,
                            newSignerEmail: newSignerEmail,
                            delegateReason: delegateReason,
                        }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Endpoint for declining a signature request
     */
    SignerAppApi.prototype.signerAppDeclineActionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, result, localVarUseFormData, formData, jsonData, body, jsonBody_2, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters["signerAppDeclineActionRequest"] == null) {
                            throw new runtime.RequiredError("signerAppDeclineActionRequest", 'Required parameter "signerAppDeclineActionRequest" was null or undefined when calling signerAppDeclineAction().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        result = runtime.generateFormData(requestParameters.signerAppDeclineActionRequest, index_1.attributeTypeMapSignerAppDeclineActionRequest);
                        localVarUseFormData = result.localVarUseFormData;
                        formData = result.formData;
                        jsonData = result.jsonData;
                        if (localVarUseFormData) {
                            /**
                             * IMPORTANT: WE MUST DELETE "Content-Type"!
                             * When a request is multipart/form-data we must NOT set Content-Type
                             * otherwise the browser will mess up the boundary!
                             */
                            delete headerParameters["Content-Type"];
                            jsonBody_2 = (0, index_1.SignerAppDeclineActionRequestToJSON)(jsonData);
                            Object.keys(jsonBody_2).forEach(function (key) {
                                if (jsonBody_2[key] == null) {
                                    return;
                                }
                                formData.append(key, jsonBody_2[key]);
                            });
                            body = formData;
                        }
                        else {
                            headerParameters["Content-Type"] = "application/json";
                            body = (0, index_1.SignerAppDeclineActionRequestToJSON)(requestParameters.signerAppDeclineActionRequest);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/signer-app/decline",
                                method: "POST",
                                headers: headerParameters,
                                query: queryParameters,
                                body: body,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return (0, index_1.SignerAppDeclineActionResponseFromJSON)(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Endpoint for declining a signature request
     */
    SignerAppApi.prototype.signerAppDeclineAction = function (signerAppDeclineActionRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.signerAppDeclineActionRaw({ signerAppDeclineActionRequest: signerAppDeclineActionRequest }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Endpoint for finalizing a signature request
     */
    SignerAppApi.prototype.signerAppFinalizeActionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, result, localVarUseFormData, formData, jsonData, body, jsonBody_3, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters["signerAppFinalizeActionRequest"] == null) {
                            throw new runtime.RequiredError("signerAppFinalizeActionRequest", 'Required parameter "signerAppFinalizeActionRequest" was null or undefined when calling signerAppFinalizeAction().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        result = runtime.generateFormData(requestParameters.signerAppFinalizeActionRequest, index_1.attributeTypeMapSignerAppFinalizeActionRequest);
                        localVarUseFormData = result.localVarUseFormData;
                        formData = result.formData;
                        jsonData = result.jsonData;
                        if (localVarUseFormData) {
                            /**
                             * IMPORTANT: WE MUST DELETE "Content-Type"!
                             * When a request is multipart/form-data we must NOT set Content-Type
                             * otherwise the browser will mess up the boundary!
                             */
                            delete headerParameters["Content-Type"];
                            jsonBody_3 = (0, index_1.SignerAppFinalizeActionRequestToJSON)(jsonData);
                            Object.keys(jsonBody_3).forEach(function (key) {
                                if (jsonBody_3[key] == null) {
                                    return;
                                }
                                formData.append(key, jsonBody_3[key]);
                            });
                            body = formData;
                        }
                        else {
                            headerParameters["Content-Type"] = "application/json";
                            body = (0, index_1.SignerAppFinalizeActionRequestToJSON)(requestParameters.signerAppFinalizeActionRequest);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/signer-app/finalize",
                                method: "POST",
                                headers: headerParameters,
                                query: queryParameters,
                                body: body,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return (0, index_1.SignerAppFinalizeActionResponseFromJSON)(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Endpoint for finalizing a signature request
     */
    SignerAppApi.prototype.signerAppFinalizeAction = function (signerAppFinalizeActionRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.signerAppFinalizeActionRaw({ signerAppFinalizeActionRequest: signerAppFinalizeActionRequest }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get transmission ready status
     */
    SignerAppApi.prototype.signerAppReadyRequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters["tsmGuid"] == null) {
                            throw new runtime.RequiredError("tsmGuid", 'Required parameter "tsmGuid" was null or undefined when calling signerAppReadyRequest().');
                        }
                        queryParameters = {};
                        if (requestParameters["tsmGuid"] != null) {
                            queryParameters["tsm_guid"] = requestParameters["tsmGuid"];
                        }
                        if (requestParameters["token"] != null) {
                            queryParameters["token"] = requestParameters["token"];
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/signer-app/ready",
                                method: "GET",
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return (0, index_1.SignerAppReadyResponseFromJSON)(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Get transmission ready status
     */
    SignerAppApi.prototype.signerAppReadyRequest = function (tsmGuid, token, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.signerAppReadyRequestRaw({ tsmGuid: tsmGuid, token: token }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Save signature request data
     */
    SignerAppApi.prototype.signerAppSaveActionRequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, result, localVarUseFormData, formData, jsonData, body, jsonBody_4, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters["signerAppSaveActionRequest"] == null) {
                            throw new runtime.RequiredError("signerAppSaveActionRequest", 'Required parameter "signerAppSaveActionRequest" was null or undefined when calling signerAppSaveActionRequest().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        result = runtime.generateFormData(requestParameters.signerAppSaveActionRequest, index_1.attributeTypeMapSignerAppSaveActionRequest);
                        localVarUseFormData = result.localVarUseFormData;
                        formData = result.formData;
                        jsonData = result.jsonData;
                        if (localVarUseFormData) {
                            /**
                             * IMPORTANT: WE MUST DELETE "Content-Type"!
                             * When a request is multipart/form-data we must NOT set Content-Type
                             * otherwise the browser will mess up the boundary!
                             */
                            delete headerParameters["Content-Type"];
                            jsonBody_4 = (0, index_1.SignerAppSaveActionRequestToJSON)(jsonData);
                            Object.keys(jsonBody_4).forEach(function (key) {
                                if (jsonBody_4[key] == null) {
                                    return;
                                }
                                formData.append(key, jsonBody_4[key]);
                            });
                            body = formData;
                        }
                        else {
                            headerParameters["Content-Type"] = "application/json";
                            body = (0, index_1.SignerAppSaveActionRequestToJSON)(requestParameters.signerAppSaveActionRequest);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/signer-app/save",
                                method: "POST",
                                headers: headerParameters,
                                query: queryParameters,
                                body: body,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Save signature request data
     */
    SignerAppApi.prototype.signerAppSaveActionRequest = function (signerAppSaveActionRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.signerAppSaveActionRequestRaw({ signerAppSaveActionRequest: signerAppSaveActionRequest }, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get signature request & signed data details
     */
    SignerAppApi.prototype.signerAppSignatureRequestGetRequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters["signatureRequestId"] == null) {
                            throw new runtime.RequiredError("signatureRequestId", 'Required parameter "signatureRequestId" was null or undefined when calling signerAppSignatureRequestGetRequest().');
                        }
                        queryParameters = {};
                        if (requestParameters["signatureRequestId"] != null) {
                            queryParameters["signature_request_id"] =
                                requestParameters["signatureRequestId"];
                        }
                        if (requestParameters["accessCode"] != null) {
                            queryParameters["access_code"] = requestParameters["accessCode"];
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/signer-app/get",
                                method: "GET",
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return (0, index_1.SignerAppSignatureRequestGetResponseFromJSON)(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Get signature request & signed data details
     */
    SignerAppApi.prototype.signerAppSignatureRequestGetRequest = function (signatureRequestId, accessCode, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.signerAppSignatureRequestGetRequestRaw({ signatureRequestId: signatureRequestId, accessCode: accessCode }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Endpoint for uploading an attachment
     */
    SignerAppApi.prototype.uploadAttachmentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, result, localVarUseFormData, formData, jsonData, body, jsonBody_5, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters["guid"] == null) {
                            throw new runtime.RequiredError("guid", 'Required parameter "guid" was null or undefined when calling uploadAttachment().');
                        }
                        if (requestParameters["signerAppUploadAttachmentRequest"] == null) {
                            throw new runtime.RequiredError("signerAppUploadAttachmentRequest", 'Required parameter "signerAppUploadAttachmentRequest" was null or undefined when calling uploadAttachment().');
                        }
                        queryParameters = {};
                        if (requestParameters["guid"] != null) {
                            queryParameters["guid"] = requestParameters["guid"];
                        }
                        headerParameters = {};
                        result = runtime.generateFormData(requestParameters.signerAppUploadAttachmentRequest, index_1.attributeTypeMapSignerAppUploadAttachmentRequest);
                        localVarUseFormData = result.localVarUseFormData;
                        formData = result.formData;
                        jsonData = result.jsonData;
                        if (localVarUseFormData) {
                            /**
                             * IMPORTANT: WE MUST DELETE "Content-Type"!
                             * When a request is multipart/form-data we must NOT set Content-Type
                             * otherwise the browser will mess up the boundary!
                             */
                            delete headerParameters["Content-Type"];
                            jsonBody_5 = (0, index_1.SignerAppUploadAttachmentRequestToJSON)(jsonData);
                            Object.keys(jsonBody_5).forEach(function (key) {
                                if (jsonBody_5[key] == null) {
                                    return;
                                }
                                formData.append(key, jsonBody_5[key]);
                            });
                            body = formData;
                        }
                        else {
                            headerParameters["Content-Type"] = "application/json";
                            body = (0, index_1.SignerAppUploadAttachmentRequestToJSON)(requestParameters.signerAppUploadAttachmentRequest);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/attachment/UploadAttachment",
                                method: "POST",
                                headers: headerParameters,
                                query: queryParameters,
                                body: body,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return (0, index_1.SignerAppUploadAttachmentResponseFromJSON)(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Endpoint for uploading an attachment
     */
    SignerAppApi.prototype.uploadAttachment = function (guid, signerAppUploadAttachmentRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.uploadAttachmentRaw({
                            guid: guid,
                            signerAppUploadAttachmentRequest: signerAppUploadAttachmentRequest,
                        }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return SignerAppApi;
}(runtime.BaseAPI));
exports.SignerAppApi = SignerAppApi;
